export const flowplayerKey = '$488948329469964'


export const salt = "axetv__100"

export const apiDomain = process.env.NODE_ENV == 'development' ?
    'http://axe-master.local' : '';

export const httpsUrl = process.env.NODE_ENV == 'development' ?
    'http://localhost:8080/' : 'https://axetv.net/user/app';

export const httpUrl = process.env.NODE_ENV == 'development' ?
    'http://localhost:8080/' : 'http://51.161.14.86/user/app';

export const adminUrl = process.env.NODE_ENV == 'development' ?
    'http://localhost:3000/#/__authorize' : 'https://admin.axetv.net/#/__authorize'

export const apiUrl = apiDomain + '/api/spa/v1';
export const apiUrlAuth = apiUrl + "/auth";

export const mode = process.env.NODE_ENV;